import AdminTradeRequestList from "../../features/admin/AdminTradeRequestList.jsx";

export default function ModerationPage() {
  return (
    <div>
      <h1>Moderation</h1>
      <AdminTradeRequestList />
    </div>
  );
}
